const initState = {
  isCollapse: false,
  notification:[],
  messages:[]
};

export default (state = initState, action) => {
  switch (action.type) {
    case "SET_COLLAPSE":
      return {
        ...state,
        isCollapse: action.payload.isCollapse,
      };
      case "SET_MESSAGE":
      return {
        ...state,
        messages: action.payload.messages,
      };
      case "SET_NOTIFICATION":
      return {
        ...state,
        notification: action.payload.notification,
      };
    default:
      return state;
  }
};
